const NS = 'CourseDetailsPage';
const CLS = 'courseDetailsPage';

import { scrollToTopButtonMixinPage } from '../../mixins/scrollToTopButtonMixinPage/scrollToTopButtonMixinPage';

export class CourseDetailsPage {
	constructor(element) {
		this.element = element;
		this.$element = $(this.element);
		this.$videoModal = this.$element.find(`#videoModal`);
		this.$close = this.$element.find(`.close`);
		this.$modal = this.$element.find(`.modal`);
		this.$iframe = this.$element.find(`.modal iframe`);
		this.$carouselSlider = this.$element.find(`.faciliatorResourcesBlock-slider`);
		$('#resources-tab').on('click',() =>{
			setTimeout(() => {
				this.$carouselSlider.slick({
					dots: true,
					dotsClass: `slick-dots`,
					autoplay: this.autoSlide,
					  autoplaySpeed: 5000,
					appendArrows: this.$sliderContainer,
					appendDots: this.$sliderContainer,
					infinite: true,
					slidesToShow: 3,
					slidesToScroll: 3,
					cssEase: 'ease-in-out',
					useTransform: true,
					adaptiveHeight: true,
					responsive: [
						{
						  breakpoint: 1024,
						  settings: {
							slidesToShow: 2,
							slidesToScroll: 2,
							infinite: true,
							dots: true
						  }
						},
						{
						  breakpoint: 767,
						  settings: {
							slidesToShow: 1,
							slidesToScroll: 1
						  }
						}
					  ]
				});
			}, 200);
		});

		this.initScrollToTopButtonMixin(this);

		this.$videoModal.on('show.bs.modal', function (event) {
			var button = $(event.relatedTarget);
			var videosrc = button.data('videosrc');
			var modal = $(this);
			modal.find('.modal-body iframe').attr('src', videosrc);
		});
		$(this.$close).on('click', (e) => {
			e.preventDefault();
			$(this.$iframe).attr('src', '');
		});

		$(this.$modal).on('click', (e) => {
			e.preventDefault();
			$(this.$iframe).attr('src', '');
		});
	}
}

Object.assign(CourseDetailsPage.prototype, scrollToTopButtonMixinPage);
